var _circle, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgQuit01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F6F4FA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "jv02nzstla",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 34.391A3.391 3.391 0 0 1 26.391 31H73.61A3.391 3.391 0 0 1 77 34.391V44a6 6 0 0 0 0 12v9.609A3.391 3.391 0 0 1 73.609 69H26.39A3.391 3.391 0 0 1 23 65.609V56a6 6 0 0 0 0-12v-9.609z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 44v2h2v-2h-2zm0 12h2v-2h-2v2zm-54 0v-2h-2v2h2zm0-12h-2v2h2v-2zm3.391-15A5.391 5.391 0 0 0 21 34.391h4c0-.768.623-1.391 1.391-1.391v-4zm47.218 0H26.39v4H73.61v-4zM79 34.391A5.391 5.391 0 0 0 73.609 29v4c.768 0 1.391.623 1.391 1.391h4zM79 44v-9.609h-4V44h4zm-6 6a4 4 0 0 1 4-4v-4a8 8 0 0 0-8 8h4zm4 4a4 4 0 0 1-4-4h-4a8 8 0 0 0 8 8v-4zm2 11.609V56h-4v9.609h4zM73.609 71A5.391 5.391 0 0 0 79 65.609h-4c0 .768-.623 1.391-1.391 1.391v4zM26.39 71H73.61v-4H26.39v4zM21 65.609A5.391 5.391 0 0 0 26.391 71v-4A1.391 1.391 0 0 1 25 65.609h-4zM21 56v9.609h4V56h-4zm6-6a4 4 0 0 1-4 4v4a8 8 0 0 0 8-8h-4zm-4-4a4 4 0 0 1 4 4h4a8 8 0 0 0-8-8v4zm-2-11.609V44h4v-9.609h-4z",
    fill: "#BE69C3",
    mask: "url(#jv02nzstla)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5 46a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm9 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm0 2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm2.707-15.793a1 1 0 0 0-1.414 0L47.065 54.935a1 1 0 1 0 1.414 1.414l12.728-12.728a1 1 0 0 0 0-1.414zM37 36a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1zm0 8a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1zm-1 9a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2zm1 7a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgQuit01);
export default __webpack_public_path__ + "static/media/img_quit_01.8de81ba587938fb06821916f18715a80.svg";
export { ForwardRef as ReactComponent };